<template>
  <v-card class="metric-card h-100">
    <v-col class="fill-height d-flex flex-column justify-center align-center text-center">

      <v-progress-circular
        :model-value="value"
        :size="100"
        :width="12"
        color="#66c7b4"
        class="progress-circle"
      >
        <div class="circular-number">{{ value }}</div>
      </v-progress-circular>

      <div class="metric-label mt-4">
        <p class="metric-title">{{ title }}</p>
        <p v-if="subTitle" class="metric-subtitle">{{ subTitle }}</p>
      </div>

    </v-col>
  </v-card>
</template>

 

<script>

export default {
    name: 'CircularProgressCard',
    props: {
        title: {
            type: String,
            default: "",
        },
        dataFetcher:{
          type: Function,
          default: null       
        },
        integerValue: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            value: this.integerValue * 20,
        }
    },
  watch: {
    integerValue(newVal) {
      this.value = newVal * 20;
    }
  },
    async mounted() {
      try {
        if (this.dataFetcher != null){
          this.value = await this.dataFetcher();
        }        
      } catch (error) {
        console.error(`Error fetching data for ${this.title}`, error);
      }

      if (this.integerValue != null){
        this.value = this.integerValue * 20;
      }
    }
}

</script>

<style scoped>
.metric-card {
  background: linear-gradient(180deg, #2b3b43 0%, #22323c 100%);
  border-radius: 12px !important;
  padding: 16px;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

.progress-circle {
  margin-bottom: 8px;
}

.circular-number {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
}

.metric-label {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.metric-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}

.metric-subtitle {
  font-size: 0.85rem;
  color: #b0bec5;
  margin: 0;
}
</style>
